/**
 * Adds an "s" suffix when count !== 1 ("field" → "fields").
 *
 * Lives in `lib/utils` (not the activity feed module) so non-React callers — e.g.
 * `lib/entity-visuals` building glyph labels for SVG/canvas — can use it without
 * pulling the activity feed's component re-exports into their import graph.
 */
export function pluralize(word: string, opts: { count: number }): string {
  return opts.count === 1 ? word : `${word}s`;
}
